<template>
    <b-container>
        <b-tabs v-model="currentTab" align="center">
            <b-tab title="Alle">
                <b>Benutzer</b>
                <br>
                <div class="float-right">
                    <b-form-input v-model="searchUser" placeholder="Nach Benutzern filtern"></b-form-input>
                </div>
                <div class="float-left">
                    <b-form-select v-model="currentSortBy" :options="sortOptions" @input="getUsers"></b-form-select>
                </div>
                <br>
                <b-table responsive bordered small :items="users" :fields="fields" :tbody-tr-class="rowClass" hover>
                    <template slot="action" slot-scope="data">
                        <b-dropdown text="Aktion" v-if="$globalStore.group === 1 || ($globalStore.group === 2 && data.item.group === 'Kunde')">
                            <b-dropdown-item @click="editUserData(data.item)">Bearbeiten</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="deleteUser(data.item.id)">Löschen</b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-table>

                <div class="float-right">
                    <b>{{ 'pagination.page' | translate(currentPageDisplay, totalPagesDisplay) }}</b>
                </div>
                <ul class="pagination">
                    <li
                        class="pagination-item"
                    >
                        <b-button
                            variant="outline-secondary"
                            @click="onClickFirstPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.first.text')"
                        >
                            << {{ 'pagination.page.first' | translate }}
                        </b-button>
                    </li>

                    <li
                        class="pagination-item"
                    >
                        <b-button
                            variant="outline-secondary"
                            @click="onClickPreviousPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.previous.text')"
                        >
                            < {{ 'pagination.page.previous' | translate }}
                        </b-button>
                    </li>
                    <li class="pagination-item">
                        <b-button
                            variant="outline-secondary"
                            @click="onClickNextPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.next.text')"
                        >
                            {{ 'pagination.page.next' | translate }} >
                        </b-button>
                    </li>

                    <li class="pagination-item">
                        <b-button
                            variant="outline-secondary"
                            @click="onClickLastPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.last.text')"
                        >
                            {{ 'pagination.page.last' | translate }} >>
                        </b-button>
                    </li>
                </ul>
            </b-tab>
            <b-tab title="Hinzufügen">
                <b>Benutzer hinzufügen</b>
                <br>
                <b-alert variant="danger" dismissible @dismissed="status = ''" :show="status.length > 0">{{ status }}</b-alert>
                <br>
                <b-form @submit.prevent="addNewUser">
                    <b-form-group
                        label="Benutzername"
                        label-for="inputUsername"
                    >
                        <b-form-input id="inputUsername" type="text" :state="newUsernameState" v-model="newUser.username"></b-form-input>

                        <b-form-invalid-feedback>
                            Mindestens 3 und maximal 30 Buchstaben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        label="E-Mail"
                        label-for="inputMail"
                    >
                        <b-form-input id="inputMail" type="mail" :state="newEmailState" v-model="newUser.email"></b-form-input>

                        <b-form-invalid-feedback>
                            Bitte eine gültige E-Mail-Adresse eingeben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group v-if="newUser.group !== 'customer' || (newUser.group === 'customer' && !newUser.sendMail)"
                        label="Passwort"
                        label-for="inputPassword"
                    >
                        <b-form-input id="inputPassword" type="password" v-model="newUser.password"></b-form-input>
                    </b-form-group>

                    <b-row>
                        <b-col>
                            <b-form-group
                                label="Vorname"
                                label-for="inputFirstName"
                            >
                                <b-form-input id="inputFirstName" type="text" v-model="newUser.firstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                label="Nachname"
                                label-for="inputLastName"
                            >
                                <b-form-input id="inputLastName" type="text" v-model="newUser.lastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group
                                label="Gruppe"
                                label-for="inputGroup"
                            >
                                <b-form-select id="inputGroup" v-model="newUser.group" >
                                    <option :value="null">Gruppe auswählen</option>
                                    <option value="admin" v-if="$globalStore.group === 1">Admin</option>
                                    <option value="customer" v-if="$globalStore.group === 1 || $globalStore.group === 2">Kunde</option>
                                    <option value="employee" v-if="$globalStore.group === 1">Mitarbeiter</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                label="Sprache"
                                label-for="inputLang"
                            >
                                <b-form-select id="inputLang" v-model="newUser.lang">
                                    <option value="de">Deutsch</option>
                                    <option value="en">Englisch</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-checkbox v-model="newUser.sendMail" v-if="newUser.group === 'customer'">Kunden über neuen Account benachrichtigen (E-Mail wird mit Link zum Passwort setzen verschickt)</b-checkbox>

                    <b-button type="submit" variant="primary" class="float-right">Hinzufügen</b-button>
                </b-form>
            </b-tab>
            <b-tab title="Bearbeiten" v-if="editUser.id !== -1">
                <b>Benutzer bearbeiten</b>
                <br>
                <b-alert variant="danger" dismissible @dismissed="status = ''" :show="status.length > 0">{{ status }}</b-alert>
                <br>
                <b-form @submit.prevent="saveEditUser" @reset.prevent="resetEditUser(); currentTab = 0;">
                    <b-form-group
                        label="Benutzername"
                        label-for="inputUsernameEdit"
                    >
                        <b-form-input id="inputUsernameEdit" type="text" :state="editUsernameState" v-model="editUser.username"></b-form-input>

                        <b-form-invalid-feedback>
                            Mindestens 3 und maximal 30 Buchstaben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        label="E-Mail"
                        label-for="inputMailEdit"
                    >
                        <b-form-input id="inputMailEdit" type="mail" :state="editEmailState" v-model="editUser.email"></b-form-input>

                        <b-form-invalid-feedback>
                            Bitte eine gültige E-Mail-Adresse eingeben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Passwort (Lassen Sie dieses Feld leer, um das Passwort nicht zu ändern)"
                                  label-for="inputPasswordEdit"
                    >
                        <b-form-input id="inputPasswordEdit" type="password" v-model="editUser.password"></b-form-input>
                    </b-form-group>

                    <b-row>
                        <b-col>
                            <b-form-group
                                label="Vorname"
                                label-for="inputFirstNameEdit"
                            >
                                <b-form-input id="inputFirstNameEdit" type="text" v-model="editUser.firstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                label="Nachname"
                                label-for="inputLastNameEdit"
                            >
                                <b-form-input id="inputLastNameEdit" type="text" v-model="editUser.lastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group
                                label="Gruppe"
                                label-for="inputGroupEdit"
                            >
                                <b-form-select id="inputGroupEdit" v-model="editUser.groupName" >
                                    <option :value="null">Gruppe auswählen</option>
                                    <option value="admin" v-if="$globalStore.group === 1">Admin</option>
                                    <option value="customer" v-if="$globalStore.group === 1 || $globalStore.group === 2">Kunde</option>
                                    <option value="employee" v-if="$globalStore.group === 1">Mitarbeiter</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                label="Sprache"
                                label-for="inputLangEdit"
                            >
                                <b-form-select id="inputLangEdit" v-model="editUser.lang">
                                    <option value="de">Deutsch</option>
                                    <option value="en">Englisch</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-button type="submit" variant="primary" class="float-right">Speichern</b-button>
                    <b-button type="reset" variant="secondary" class="float-right">Abbrechen</b-button>
                </b-form>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Users",
        data() {
            return {
                users: [],
                fields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'username',
                        label: 'Nutzername'
                    },
                    {
                        key: 'email',
                        label: 'E-Mail'
                    },
                    {
                        key: 'firstName',
                        label: 'Vorname'
                    },
                    {
                        key: 'lastName',
                        label: 'Nachname'
                    },
                    {
                        key: 'group',
                        label: 'Gruppe',
                    },
                    {
                        key: 'action',
                        label: 'Aktion',
                    }
                ],
                sortOptions: [
                    { value: 'u.username asc', text: 'Nutzername aufsteigend' },
                    { value: 'u.username desc', text: 'Nutzername absteigend' },
                    { value: 'u.email asc', text: 'E-Mail aufsteigend' },
                    { value: 'u.email desc', text: 'E-Mail absteigend' },
                    { value: 'u.last_name asc', text: 'Nachname aufsteigend' },
                    { value: 'u.last_name desc', text: 'Nachname absteigend' }
                ],
                currentTab: 0,
                groups: ['Admin', 'Kunde', 'Benutzer'],
                newUser:
                    {
                        username: '',
                        email: '',
                        password: '',
                        firstName: '',
                        lastName: '',
                        group: null,
                        lang: 'de',
                        sendMail: true
                    },
                editUser: {
                    id: -1,
                    username: '',
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    groupName: '',
                    lang: 'de'
                },
                status: '',
                currentPage: 1,
                currentPageDisplay: 1,
                totalPages: 1,
                totalPagesDisplay: 1,
                searchUser: '',
                filterMode: false,
                currentSortBy: 'u.username asc'
            }
        },
        methods: {
            onClickFirstPage: function () {
                this.currentPage = 1;

                this.getUsers();
            },
            onClickLastPage: function () {
                this.currentPage = 0;

                this.getUsers();
            },
            onClickNextPage: function () {
                this.currentPage++;

                this.getUsers();
            },
            onClickPreviousPage: function () {
                this.currentPage--;

                this.getUsers();
            },
            getUsers: function () {
                let endpoint = !this.filterMode ? 'https://drop.rautec.de/api/users/' + this.currentPage + '/' + this.currentSortBy.split(" ")[0] + '/' + this.currentSortBy.split(" ")[1] :
                    'https://drop.rautec.de/api/users/' + this.currentPage + '/' + this.searchUser;

                axios.get(endpoint).then(response => {
                    if (response.data.users) {
                        this.users = response.data.users;
                    }

                    this.currentPage = response.data.currentPage;
                    this.currentPageDisplay = response.data.currentPage;
                    this.totalPages = response.data.totalPages;
                    this.totalPagesDisplay = response.data.totalPages;
                });
            },
            editUserData: function (user) {
                this.editUser.id = user.id;
                this.editUser.username = user.username;
                this.editUser.email = user.email;
                this.editUser.password = user.password;
                this.editUser.firstName = user.firstName;
                this.editUser.lastName = user.lastName;
                this.editUser.groupName = user.groupName;
                this.editUser.lang = user.lang;

                setTimeout(() => {
                    this.currentTab = 2;
                }, 25);
            },
            saveEditUser: function () {
                if (this.editUser.username.trim().length === 0 || this.editUser.email.trim().length === 0 || this.editUser.firstName.trim().length === 0 || this.editUser.lastName.trim().length === 0 || !this.editUser.groupName || (this.editUser.password !== undefined && this.editUser.password.trim().length === 0)) {
                    this.status = 'Bitte alle Felder ausfüllen.';
                    return;
                }

                if (!this.isValidMail(this.editUser.email)) {
                    this.status = 'Bitte eine korrekte E-Mail eingeben.';
                    return;
                }

                if (this.editUser.username.length < 3 || this.editUser.username.length > 30) {
                    return;
                }

                this.status = '';

                axios.put('https://drop.rautec.de/api/users/' + this.editUser.id, {
                    username: this.editUser.username,
                    email: this.editUser.email,
                    password: this.editUser.password,
                    firstName: this.editUser.firstName,
                    lastName: this.editUser.lastName,
                    groupName: this.editUser.groupName,
                    lang: this.editUser.lang
                }).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Benutzer erfolgreich gespeichert.');

                        this.getUsers();

                        this.resetEditUser();

                        this.currentTab = 0;
                    } else {
                        this.$toastError('Benutzer konnte nicht gespeichert werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Anfrage.');
                })
            },
            resetEditUser: function () {
                this.editUser.id = -1;
                this.editUser.username = '';
                this.editUser.email = '';
                this.editUser.password = '';
                this.editUser.firstName = '';
                this.editUser.lastName = '';
                this.editUser.groupName = '';
                this.editUser.lang = 'de';
            },
            addNewUser: function () {
                if (this.newUser.username.trim().length === 0 || this.newUser.email.trim().length === 0 || this.newUser.firstName.trim().length === 0 || this.newUser.lastName.trim().length === 0 || !this.newUser.group || (this.newUser.password.trim().length === 0 && this.newUser.group !== 'customer' && !this.newUser.sendMail)) {
                    this.status = 'Bitte alle Felder ausfüllen.';
                    return;
                }

                if (!this.isValidMail(this.newUser.email)) {
                    this.status = 'Bitte eine korrekte E-Mail eingeben.';
                    return;
                }

                if (this.newUser.username.length < 3 || this.newUser.username.length > 30) {
                    return;
                }

                this.status = '';

                let formData = new FormData();
                let trimmedUsername = this.newUser.username.trim();
                formData.append('username', this.newUser.group === 'customer' ? trimmedUsername.toLowerCase() : trimmedUsername);
                formData.append('email', this.newUser.email.trim());
                formData.append('password', this.newUser.password.trim());
                formData.append('firstName', this.newUser.firstName.trim());
                formData.append('lastName', this.newUser.lastName.trim());
                formData.append('groupName', this.newUser.group);
                formData.append('lang', this.newUser.lang);
                if (this.newUser.group === 'customer') {
                    formData.append('mail', this.newUser.sendMail);
                }

                axios.post('https://drop.rautec.de/api/users', formData).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Benutzer erfolgreich hinzugefügt.');

                        this.newUser.username = '';
                        this.newUser.email = '';
                        this.newUser.password = '';
                        this.newUser.firstName = '';
                        this.newUser.lastName = '';
                        this.newUser.group = null;
                        this.newUser.lang = 'de';

                        this.getUsers();
                    } else if (response.data.duplicated) {
                        this.status = 'Benutzer mit dem Nutzernamen existiert bereits.';
                    } else {
                        this.$toastError('Benutzer konnte nicht hinzugefügt werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Anfrage.');
                });
            },
            deleteUser: function (userId) {
                axios.delete('https://drop.rautec.de/api/users/' + userId).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Benutzer erfolgreich gelöscht.');

                        this.getUsers();
                    } else {
                        this.$toastError('Benutzer konnte nicht gelöscht werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Anfrage.');
                });
            },
            isValidMail: function (email) {
                if (email.length < 1) {
                    return false;
                }

                let mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return mailRegex.test(email.toLowerCase());
            }
        },
        watch: {
            searchUser: function (value, oldValue) {
                if (value === '' && oldValue !== '') {
                    this.filterMode = false;
                    this.getUsers();
                    return;
                }

                if (value.length > 0 && !this.filterMode) {
                    this.filterMode = true;
                }

                this.getUsers();
            },
            currentTab: function (value, oldValue) {
                // If the tab is switched and oldValue is the edit user tab, reset the edit user
                if (oldValue === 2) {
                    this.resetEditUser();
                }
            }
        },
        computed: {
            newUsernameState() {
                return this.newUser.username.trim().length > 2 && this.newUser.username.trim().length < 31;
            },
            newEmailState() {
                return this.newUser.email.trim().length > 0 && this.isValidMail(this.newUser.email);
            },
            editUsernameState() {
                return this.editUser.username.trim().length > 2 && this.editUser.username.trim().length < 31;
            },
            editEmailState() {
                return this.editUser.email.trim().length > 0 && this.isValidMail(this.editUser.email);
            }
        },
        mounted() {
            this.getUsers();
        }
    }
</script>

<style scoped>
    .pagination {
        list-style-type: none;
        display: flex;
        justify-content: center;
    }

    .pagination-item {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users.vue